<template lang="pug">
  #app
    #background-clouds
      .cloud1
      .cloud2
      .cloud3
      .cloud4
    #flying-objects
      .purple-bird-left
      .pink-bird-left
      .hotair-balloon-left
      .green-bird-right
      .pink-bird-right
      .hotair-balloon-right
    Nav
      //- router-link(to="/") Home |
      //- router-link(to="/about") About
    router-view
    Foot
</template>
<script>
import Nav from '@/components/Navigation.vue'
import Foot from '@/components/Footer.vue'

export default {
  name: 'Main',
  metaInfo: {
    title: 'Smales Thailand',
    titleTemplate: '%s | Membership'
  },
  components: {
    Nav,
    Foot
  }
}
</script>

<style lang="sass">
@import "./sass/variables"

@font-face
  font-family: 'kids-comic'
  src: url('/assets/static/fonts/kidsn-webfont.woff')

@font-face
  font-family: 'NotoIKEALatin'
  src: url('/assets/fonts/NotoIKEALatin-Regular.ttf')

@font-face
  font-family: 'NotoIKEALatin'
  src: url('/assets/fonts/NotoIKEALatin-Bold.ttf')
  font-weight: bold

@font-face
  font-family: 'NotoIKEAThai'
  src: url('/assets/static/fonts/NotoIKEAThai-Regular.ttf')

@font-face
  font-family: 'NotoIKEAThai'
  src: url('/assets/static/fonts/NotoIKEAThai-Bold.ttf')
  font-weight: bold

*
  box-sizing: border-box

html,
body
  margin: 0
  padding: 0
  height: 100%
  font-family: 'NotoIKEAThai', 'Noto Sans', sans-serif
  background-color: #ffffff
  background-image: url('./assets/images/site.png')
  +mobile
    background-color: transparent

  @media #{$mobile}
    background-image: none

#flying-objects
  width: 100%
  position: absolute
  overflow: hidden

  @media #{$mobile}
    display: none

  .purple-bird-left
    position: fixed
    background: url('./assets/images/bird_purplel.png')
    width: 48px
    height: 40px
    top: 30%
    left: 17%
    animation-name: purpleBird
    animation-duration: 1s
    animation-iteration-count: infinite
    animation-direction: alternate
    animation-timing-function: ease-in-out
    @media (max-width: 1300px)
      left: 7%

  .pink-bird-left
    position: fixed
    background: url('./assets/images/bird_pinkl.png')
    width: 35px
    height: 28px
    top: 35%
    left: 19%
    animation-name: pinklBird
    animation-duration: 1.5s
    animation-iteration-count: infinite
    animation-direction: alternate
    animation-timing-function: ease-in-out
    @media (max-width: 1300px)
      left: 9%

  .hotair-balloon-left
    position: fixed
    background: url('./assets/images/hotair-balloon01.png')
    width: 72px
    height: 104px
    top: 22%
    left: 20%
    animation-name: greenBalloon
    animation-duration: 1s
    animation-iteration-count: infinite
    animation-direction: alternate
    animation-timing-function: ease-out
    @media (max-width: 1300px)
      left: 10%

  .green-bird-right
    position: fixed
    background: url('./assets/images/bird_greenr.png')
    width: 50px
    height: 35px
    top: 33%
    right: 22%
    animation-name: greenrBird
    animation-duration: 1s
    animation-iteration-count: infinite
    animation-direction: alternate
    animation-timing-function: ease-in-out
    @media (max-width: 1300px)
      right: 12%

  .pink-bird-right
    position: fixed
    background: url('./assets/images/bird_pinkr.png')
    width: 40px
    height: 29px
    top: 38%
    right: 20%
    animation-name: pinkrBird
    animation-duration: 2s
    animation-iteration-count: infinite
    animation-direction: alternate
    animation-timing-function: ease-in-out
    @media (max-width: 1300px)
      right: 10%

  .hotair-balloon-right
    position: fixed
    background: url('./assets/images/hotair-balloon02.png')
    width: 58px
    height: 80px
    top: 26%
    right: 19%
    animation-name: redBalloon
    animation-duration: 1.5s
    animation-iteration-count: infinite
    animation-direction: alternate
    animation-timing-function: ease-in-out
    @media (max-width: 1300px)
      right: 9%

#background-clouds
  width: 100%
  position: absolute
  overflow: hidden

  @media #{$mobile}
    display: none

  .cloud1
    position: fixed
    background: url('./assets/images/clouds/cloud01.png')
    width: 131px
    height: 82px
    top: 20%
    left: 10%

  .cloud2
    position: fixed
    background: url('./assets/images/clouds/cloud02.png')
    width: 178px
    height: 111px
    top: 50%
    left: 25%

  .cloud3
    position: fixed
    background: url('./assets/images/clouds/cloud03.png')
    width: 115px
    height: 71px
    top: 40%
    right: 10%

  .cloud4
    position: fixed
    background: url('./assets/images/clouds/cloud04.png')
    width: 107px
    height: 69px
    top: 60%
    right: 20%

#app-container
  min-height: 100%
  position: relative
  display: none

  &.active
    display: block

#main
  padding-top: 30px
  padding-bottom: 315px
  +desktop
    z-index: 2
  @media #{$mobile}
    padding-top: 20px
    padding-bottom: 150px

.container
  max-width: 850px
  margin: 30px auto 0
  padding-bottom: 50px
  @media #{$mobile}
    padding-top: 30px
    padding-bottom: 50px
    padding-left: 20px
    padding-right: 20px

a
  color: #0099CC

@keyframes greenBalloon
  0%
    top: 22%

  100%
    top: 23%


@keyframes redBalloon
  0%
    top: 26%

  100%
    top: 27%


@keyframes purpleBird
  0%
    top: 30%

  100%
    top: 31%


@keyframes pinklBird
  0%
    top: 35%

  100%
    top: 36%


@keyframes pinkrBird
  0%
    top: 38%

  100%
    top: 39%


@keyframes greenrBird
  0%
    top: 33%

  100%
    top: 34%

</style>
